import { useBrandRequestContext } from '@/layouts/Brand/BrandRequestContext';
import {
  isArchived,
  isArchivedAndExportedToZendesk,
  isInAnalysisStep,
  isInCompletedStep,
  isInDraftStep,
  isInFirstServiceChoiceStep,
  isInInitialTransitStep,
  isInLaterServiceChoiceStep,
  isInPaymentStep,
  isInProcessingStep,
  isInRepairStep,
  isInTransitStep,
  isInValidationStep,
} from '@/models/request';
import { ArchivedNone } from '@/routes/Brand/Requests/Request/components/shared/ArchivedNone';
import UnhandledStep from '@/routes/Brand/Requests/Request/components/shared/UnhandledStep';

import Analysis from './components/Analysis';
import { Archived } from './components/Archived';
import { Completed } from './components/Completed';
import { Delivery } from './components/Delivery';
import Estimation from './components/Estimation';
import Payment from './components/Payment';
import Repair from './components/Repair';
import Transit from './components/Transit';

const StoreRequestView = () => {
  const { request } = useBrandRequestContext();

  if (isArchived(request) && !isArchivedAndExportedToZendesk(request)) {
    const shouldRequestFeedback = request.articles.some((article) => !!article.repairedAt);
    const isServiceChoiceNone = request.allArticles.every(
      (article) => article.snapshot.serviceChoice === 'none'
    );

    if (shouldRequestFeedback) {
      return <Completed request={request} />;
    } else if (isServiceChoiceNone) {
      return <ArchivedNone request={request} />;
    } else {
      return <Archived request={request} />;
    }
  }

  if (
    isInDraftStep(request) ||
    isInFirstServiceChoiceStep(request) ||
    isInValidationStep(request) ||
    isArchivedAndExportedToZendesk(request)
  ) {
    return <Estimation request={request} />;
  }

  if (isInInitialTransitStep(request)) {
    return <Transit request={request} />;
  }

  const isRequestInTransitAfterRequalificationRefused = request.articles.some(
    (article) => !!article.requalificationRefusedAt
  );

  if (
    isInAnalysisStep(request) ||
    isInLaterServiceChoiceStep(request) ||
    isRequestInTransitAfterRequalificationRefused
  ) {
    return <Analysis request={request} />;
  }

  if (isInPaymentStep(request)) {
    return <Payment request={request} />;
  }

  if (isInRepairStep(request) || isInProcessingStep(request)) {
    return <Repair request={request} />;
  }

  if (isInTransitStep(request)) {
    return <Delivery request={request} />;
  }

  if (isInCompletedStep(request)) {
    return <Completed request={request} />;
  }

  // If we reach this point, it means that the request is in an unknown step
  // We are still showing something as not to scare the user
  // But we are also sending an error to Sentry
  return <UnhandledStep request={request} />;
};

export default StoreRequestView;
